import ChartContainer from '../Services/charts/apex-charts/ChartContainer';

export const AgePyramid = ({
    title,
    categories = [],
    male = [],
    female = [],
    maleColor = '#0D82D3',
    femaleColor = '#5ECFC1',
    height = 400
}) => {
    const series = [
        { name: 'Masculino', data: male.map((value) => -Math.abs(value || 0)) },
        { name: 'Feminino', data: female.map((value) => Math.abs(value || 0)) }
    ];

    const options = {
        chart: {
            type: 'bar',
            height,
            toolbar: {
                show: true
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 2,
                columnWidth: '70%'
            }
        },
        colors: [maleColor, femaleColor],
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories,
            labels: {
                style: {
                    fontSize: '12px',
                    colors: '#333'
                }
            }
        },
        yaxis: {
            labels: {
                formatter: (val) => Math.round(val).toLocaleString('pt-BR'),
                style: {
                    fontSize: '12px'
                }
            }
        },
        legend: {
            show: true,
            position: 'bottom'
        },
        tooltip: {
            y: {
                formatter: (val) => (val || val === 0 ? Math.abs(val).toLocaleString('pt-BR') : '')
            }
        },
        grid: {
            show: true,
            borderColor: '#e0e0e0',
            xaxis: {
                lines: {
                    show: false
                }
            }
        }
    };

    return (
        <ChartContainer
            title={title}
            options={options}
            series={series}
            type="bar"
            height={height}
        />
    );
};
